import clsx from "clsx";
import { ChangeEvent, useEffect, useState } from "react";

// Interfaces
import { IMarkAsExportedProps, IProcessOptions, IProcessOptionsProps } from "./interfaces";

// MUI
import { Checkbox, FormControlLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material";

const RadioControlContent = (props: Readonly<IProcessOptions>) => {
	const { label, value, disabled = false } = props ?? {};
	return (
		<FormControlLabel
			value={value}
			control={
				<Radio
					size="small"
					disabled={disabled}
					disableFocusRipple
					disableRipple
					className={clsx({
						"[&_.MuiSvgIcon-root]:!text-[16px]": true,
						"[&.Mui-checked]:!text-primary  !text-primary": !disabled,
						"!text-disabled": disabled,
					})}
				/>
			}
			label={
				<Typography
					className={clsx({
						"!font-sans !text-[14.5px] !font-normal": true,
						"!text-default": !disabled,
						"!text-disabled": disabled,
					})}
				>
					{label}
				</Typography>
			}
		/>
	);
};

export default function CitProcessOptions(props: Readonly<IProcessOptionsProps>) {
	const { disabled = false, defaultOption = "", options = [], onProcessChange = () => {} } = props ?? {};

	// States
	const [activeProcess, setActiveProcess] = useState(defaultOption);

	const handleProcessChange = (event: ChangeEvent<HTMLInputElement>): void => {
		const process = event.target.value as string;
		setActiveProcess(process);
		onProcessChange?.(process);
	};

	useEffect(() => {
		return () => {
			setActiveProcess(defaultOption);
		};
	}, []);

	return (
		<RadioGroup
			row
			aria-labelledby="radio-buttons-group-export-process-label"
			name="radio-buttons-group-export-process"
			className="gap-2"
			value={activeProcess}
			onChange={handleProcessChange}
		>
			{options.map((process: IProcessOptions) => {
				const controlDisabled = process.disabled || disabled;
				const { key, ...processProps } = process;
				return <RadioControlContent key={key} {...processProps} disabled={controlDisabled} />;
			})}
		</RadioGroup>
	);
}

export function MarkAsExported(props: Readonly<IMarkAsExportedProps>) {
	const { children, isDisabled, isChecked, onChange } = props ?? {};

	return (
		<Stack direction="column" spacing={-1}>
			{children}

			<FormControlLabel
				className="!ml-[-13px]"
				label={
					<Typography
						className={clsx("!font-sans !text-[14.5px] !font-normal", {
							"!text-default": !isDisabled,
							"!text-disabled": isDisabled,
						})}
					>
						Mark as exported
					</Typography>
				}
				control={<Checkbox disableRipple size="small" disabled={isDisabled} checked={isChecked} onChange={onChange} />}
			/>
		</Stack>
	);
}
